<!-- TODO: universal component for template, and optimize this component.-->
@switch (column.type) {
	@case (COLUMN_TYPES.ID) {
		<div class="id-column">
			<au-body-text-grey [text]="getData(item, column.key)"></au-body-text-grey>
		</div>
	}
	@case (COLUMN_TYPES.GREY_TEXT) {
		<div class="grey-text-column">
			<au-body-text-grey [text]="getData(item, column.key)"></au-body-text-grey>
		</div>
	}
	@case (COLUMN_TYPES.BODY_HEADING) {
		<div class="heading-text-column">
			<au-body-text-heading
				[text]="getData(item, column.key)"
				[item]="item"
				[iconKey]="column.customData?.iconKey"
				(selectElement)="selectElement.emit(item)"
				[isClickable]="column.customData?.isClickable"
				[nonBold]="column.customData?.nonBold"
			>
			</au-body-text-heading>
		</div>
	}
	@case (COLUMN_TYPES.TEXT) {
		<div class="text-column">
			<au-body-text
				[text]="getData(item, column?.customData?.key || column.key)"
			></au-body-text>
		</div>
	}
	@case (COLUMN_TYPES.PRIORITY) {
		<div class="priority-column">
			<au-priority-level [level]="getData(item, column.key)"></au-priority-level>
		</div>
	}
	@case (COLUMN_TYPES.LINKED_LIST) {
		<div class="linked-list-column">
			<au-linked-object-list
				[items]="getData(item, column.key) || []"
				[key]="column.customData?.key"
				[maxItemsInRow]="2"
				(openLinkPressed)="openLinkPressed($event)"
			>
			</au-linked-object-list>
		</div>
	}
	@case (COLUMN_TYPES.AVATAR) {
		<div class="avatar-with-text-column">
			<au-avatar-with-name [data]="getData(item, column.key)" [size]="40">
			</au-avatar-with-name>
		</div>
	}
	@case (COLUMN_TYPES.STATUS) {
		<div class="status-column">
			<au-cmms-status-label [status]="getData(item, column.key)"></au-cmms-status-label>
		</div>
	}
	@case (COLUMN_TYPES.DATE_AGO) {
		<div class="date-column">
			<au-body-text [text]="getData(item, column.key) | dateAgo"></au-body-text>
		</div>
	}
	@case (COLUMN_TYPES.DATE) {
		<div [ngClass]="IsOutdated(item) ? 'expired date-column' : 'date-column'">
			<au-body-text [text]="getData(item, column.key) | date"></au-body-text>
		</div>
	}
	@case (COLUMN_TYPES.DATE_TIME) {
		<div [ngClass]="IsOutdated(item) ? 'expired date-column' : 'date-column'">
			<au-body-text
				[text]="getData(item, column.key) | date: 'dd.MMM.yyyy kl. HH:mm'"
			></au-body-text>
		</div>
	}
	@case (COLUMN_TYPES.LINKED_BTN) {
		@if (getData(item, column?.customData?.key || column.key)?.length) {
			<au-linked-object-btn
				(clicked)="$event.stopPropagation(); openLinkPressed(item)"
				[clickable]="
					column?.customData?.isClickable === undefined
						? true
						: column?.customData?.isClickable
				"
				[text]="getData(item, column?.customData?.key || column.key)"
			>
			</au-linked-object-btn>
		}
		@if (!getData(item, column?.customData?.key || column.key)?.length) {
			<span class="no-data"> </span>
		}
	}
	@case (COLUMN_TYPES.FILE_NAME) {
		<!--We should use file entity name not a file itself,
    but the file type for icon is inside file itself -->
		<au-file-name
			[name]="getData(item, column.key)"
			[fileData]="getData(item, 'file')"
			(openFile)="selectElement.emit(item)"
		></au-file-name>
	}
	@case (COLUMN_TYPES.KEY_VALUE) {
		<au-key-value-text
			[key]="getData(item, column.key)"
			[valueListKey]="column.customData?.valueList"
		></au-key-value-text>
	}
	@case (COLUMN_TYPES.CLASSIFICATION) {
		<au-classification-badge
			[classifications]="getData(item, column.key)"
			[filterBy]="column.customData.filteredBy"
		/>
		<au-classification-suggestion-badge
			[suggestions]="getClassificationSuggestionsData(item)"
			[fileId]="item.pk"
		/>
	}
	@case (COLUMN_TYPES.LOCATIONS) {
		<au-expandable-tags
			[tags]="getDataForLocations(getData(item, column.key))"
			[initSize]="2"
		></au-expandable-tags>
		@if (!getDataForLocations(getData(item, column.key))?.length) {
			<span class="no-data"> </span>
		}
	}
	@case (COLUMN_TYPES.DOCUMENT_TYPE) {
		<div class="document-type-column">
			<au-document-type [type]="getData(item, column.key)" />
		</div>
	}
	@case (COLUMN_TYPES.COST) {
		<div class="cost-column">
			@if (getData(item, column.key)) {
				<span>
					{{ getData(item, column.key).replace('.', ',') | mask: 'separator,2' }}
				</span>
				<span>NOK</span>
			}
		</div>
	}
	@case (COLUMN_TYPES.NS_COLUMN) {
		<div class="ns-column">
			<au-ns-column [value]="getData(item, column.key)" />
		</div>
	}
	@case (COLUMN_TYPES.LABELS) {
		<div class="label-column">
			<au-cmms-label-column
				[labels]="getData(item, column.key)"
				(viewMoreClicked)="selectElement.emit(item)"
			/>
		</div>
	}
	@case (COLUMN_TYPES.CONDITION_GRADE) {
		<div class="condition-grade-column">
			@if (getData(item, column.key) || getData(item, column.key) === 0) {
				<asset-condition-grade
					[showLabel]="false"
					[staticValue]="true"
					[conditionGrade]="getData(item, column.key)"
				/>
			}
		</div>
	}
	@case (COLUMN_TYPES.REQUESTER) {
		<cmms-autocomplete-contact
			[requestees]="getData(item, column.key)"
			[editMode]="false"
			[allowEdit]="false"
		/>
	}
}
